import App from './App.svelte';

const app = new App({
	// document.body is for devel, menu-inner is for when this is embedded in Spellmasons
	target: document.getElementById('menu-app') || document.body,
	props: {}
});

export default app;